import type { MetaInfo } from 'vue-meta';

export const getMetaInfo = (page: any, isNoIndex: boolean = false): MetaInfo => {
  if (!page) {
    return null;
  }

  const seoTags: MetaInfo = {
    meta: [],
  };

  if (page?.meta_title || page?.title || page?.name) {
    seoTags.title = page?.meta_title || page?.title || page?.name;
    seoTags.meta.push({
      hid: 'og:title',
      name: 'og:title',
      content: page?.meta_title || page?.title || page?.name,
    });
  }
  if (page?.meta_description || page?.description?.html) {
    seoTags.meta.push({
      hid: 'description',
      name: 'description',
      content: page.meta_description || page.description.html.replace(/(<([^>]+)>)/ig, ''),
    });
    seoTags.meta.push({
      hid: 'og:description',
      name: 'og:description',
      content: page.meta_description || page.description.html.replace(/(<([^>]+)>)/ig, ''),
    });
  }
  if (page?.meta_keyword || page?.meta_keywords) {
    seoTags.meta.push({
      hid: 'keywords',
      name: 'keywords',
      content: page?.meta_keyword || page?.meta_keywords,
    });
  }
  if (page?.meta_keyword || page?.meta_keywords) {
    seoTags.meta.push({
      hid: 'keywords',
      name: 'keywords',
      content: page?.meta_keyword || page?.meta_keywords,
    });
  }
  if (page?.image || page?.image?.url) {
    seoTags.meta.push({
      hid: 'og:image',
      name: 'og:image',
      content: page.image.url,
    });
  }
  if (isNoIndex) {
    seoTags.meta.push({
      name: 'robots',
      content: 'noindex, nofollow',
    });
  }

  return seoTags;
};
